<template>
  <EmptyListingBlock class="custom-lists-empty" :useDefaultImage="true">
    <p class="custom-lists-empty__text">
      Books you add to this list will appear here. To add a book, click on the
      <span class="iconfont iflag2"></span> icon on the book card, then on "Add
      to List" and select one of the lists.
    </p>

    <div class="custom-lists-empty__links">
      <AppButton
        :outlined="true"
        class="custom-lists-empty__btn custom-lists-empty__btn--books"
        tag="router-link"
        :to="{ name: 'books' }"
        >Go to Books</AppButton
      >
      <AppButton
        class="custom-lists-empty__btn custom-lists-empty__btn--search"
        tag="router-link"
        :to="{ name: 'search' }"
        >Go to Search</AppButton
      >
    </div>
  </EmptyListingBlock>
</template>

<script setup lang="ts">
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'
import AppButton from '@/app/components/button/AppButton.vue'
</script>

<style lang="scss" scoped>
.custom-lists-empty {
  &__links {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 16px;

    @media (max-width: $w-medium-s) {
      flex-direction: column-reverse;
    }
  }

  &__text .iconfont {
    font-size: 1.15em;
  }
}
</style>
